import { render } from "./DaftarBerita.vue?vue&type=template&id=64912d31"
import script from "./DaftarBerita.vue?vue&type=script&lang=js"
export * from "./DaftarBerita.vue?vue&type=script&lang=js"

import "./DaftarBerita.vue?vue&type=style&index=0&id=64912d31&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__